import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

const Selects = (props) => {
  const { options, fullWidth = false, ...rest } = props;
  return (
    <FormControl variant="outlined" fullWidth={fullWidth}>
      <InputLabel htmlFor="age-native-simple">{props.label}</InputLabel>
      <Select {...rest}>
        {options &&
          options.map((option, index) => (
            <MenuItem key={index} value={option.code}>
              {option.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default Selects;
